import useBRData from "./usebrdata";

const useLineUp = (teamId, accessKey) => {
  const { data } = useBRData("lu", { teamid: teamId }, accessKey);

  return { data: data.lineups && data.lineups.length > 0 ? data.lineups[0] : [] };
};

export default useLineUp;
